<template>
  <!-- 批量导入精英青训教练员 -->
  <div class="add-group-wrapper">
    <el-dialog
      :visible.sync="isVisible"
      width="500px"
      title="批量导入"
      :close-on-click-modal="false"
      custom-class="add-sup-group"
    >
      <div class="scroll-wrapper">
        <vue-scroll :ops="ops">
          <div class="form-wrapper">
            <el-form
              ref="add_group"
              :model="supForm"
              :rules="supRules"
              label-width="110px"
            >
              <el-form-item label="开始日期" prop="startDate">
                <el-date-picker
                  v-model="supForm.startDate"
                  type="date"
                  placeholder="请选择开始日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="startDateOptions"
                  class="yioks-w100"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="supForm.endDate"
                  type="date"
                  placeholder="请选择结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="endDateOptions"
                  class="yioks-w100"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="年份" prop="year">
                <el-input
                  v-model="supForm.year"
                  placeholder="请输入年份"
                  class="yioks-w100"
                  :disabled="supForm.year ? true : false"
                ></el-input>
              </el-form-item>

              <el-form-item label="期数" prop="period">
                <el-input
                  v-model.number="supForm.period"
                  type="number"
                  min="0"
                  placeholder="请输入期数"
                  class="yioks-w100"
                ></el-input>
              </el-form-item>

              <el-form-item label="地点" prop="address">
                <el-input
                  v-model="supForm.address"
                  placeholder="请输入地点"
                  class="yioks-w100"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-for="(item, index) in supForm.courseList"
                :key="index"
                :prop="`courseList.${index}.course_content`"
                :rules="[
                  { required: true, message: '信息不能为空', trigger: 'blur' },
                ]"
                :label="`${item.course_label}${index + 1}`"
                :error="item.course_error"
              >
                <div class="action-wrapper">
                  <el-input
                    v-model="item.course_content"
                    :placeholder="item.course_placeholer"
                    class="yioks-w75"
                  ></el-input>
                  <div
                    v-if="supForm.courseList.length - 1 === index"
                    class="action-icon add-icon"
                    @click="handleAddCourse"
                  >
                    <i class="el-icon-circle-plus-outline"></i>
                  </div>
                  <div
                    v-if="supForm.courseList.length > 1"
                    class="action-icon delete-icon"
                    @click="handleDeleteCourse(index)"
                  >
                    <i class="el-icon-remove-outline"></i>
                  </div>
                </div>
              </el-form-item>

              <UploadFile
                v-if="isVisible"
                request="/api/zuxie/guozi/coach/ExcelElite"
                :templateFile="tempUrl"
                @callBack="uploadFileSuccess"
              />
            </el-form>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import coach from "@/api/coach";
import { requiredItem } from "@/assets/js/formRules";

export default {
  name: "AddSupGroup",

  props: {
    isShowDialog: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    isVisible: {
      get() {
        return this.isShowDialog;
      },
      set(val) {
        this.$emit("hideDialog", val, false);
      },
    },

    startDateOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.supForm.endDate) {
            return time.getTime() > Date.parse(that.supForm.endDate);
          } else {
            return false;
          }
        },
      };
    },

    endDateOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.supForm.startDate) {
            return time.getTime() < Date.parse(that.supForm.startDate);
          } else {
            return false;
          }
        },
      };
    },

    tempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/coachEliteClub.xlsx";
      } else {
        return "/uploads/templateFile/coachElite.xlsx";
      }
    },
  },

  watch: {
    "supForm.startDate": {
      handler(newVal, oldVal) {
        if (newVal) {
          const timeList = newVal.split("-");
          this.$set(this.supForm, "year", timeList[0]);
        } else {
          this.$set(this.supForm, "year", 0);
        }
        // console.log('this.supForm', this.supForm)
      },
    },
  },

  components: {
    UploadFile: () => import("@/components/UploadFile"),
  },

  data() {
    return {
      ops,
      supForm: {
        address: "",
        course: "", // JSON字符串
        courseList: [
          {
            course_label: "课程",
            course_content: "",
            course_error: "",
            course_placeholer: "请输入课程",
          },
        ], // 对应course的列表
        endDate: "",
        startDate: "",
        year: "",
        period: "",
        path: "", // 上传文件路径
      },
      supRules: {
        startDate: [requiredItem("开始日期", true)],
        endDate: [requiredItem("结束日期", true)],
        year: [requiredItem("年份", true)],
        period: [requiredItem("期数", true)],
        address: [requiredItem("地址")],
      },
    };
  },

  methods: {
    // 文件上传成功方法回调
    uploadFileSuccess(url) {
      this.$set(this.supForm, "path", url);
      this.$refs["add_group"].validate((valid) => {
        if (valid) {
          const { courseList, ...rest } = this.supForm;
          const tempList = courseList.map((item) => item.course_content);
          const course = JSON.stringify(tempList);
          const submitData = Object.assign({}, rest, { course });
          coach
            .importGroupCoachElite(submitData)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
                return;
              }
              this.$message.success("数据导入成功！");
              this.$emit("hideDialog", false, true);
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          console.warn("表单校验失败");
        }
      });

      // console.log('handled submit data: ', this.supForm)
    },

    handleAddCourse() {
      const newCourse = {
        course_label: "课程",
        course_content: "",
        course_error: "",
        course_placeholer: "请输入课程",
      };
      const { courseList } = this.supForm;
      courseList.push(newCourse);
      this.$set(this.supForm, "courseList", courseList);
    },
    handleDeleteCourse(index) {
      const { courseList } = this.supForm;
      courseList.splice(index, 1);
      this.$set(this.supForm, "courseList", courseList);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.scroll-wrapper
  height 450px
.form-wrapper
  margin-right 30px
.yioks-w100
  width 100%
.yioks-w75
  width 65%
.action-wrapper
  display flex
  margin-bottom 10px
  .action-icon
    width 35px
    display flex
    align-items center
    justify-content center
    border-radius 50%
    height 35px
    color $color_white
    font-size 2em
    margin 0 5px
    cursor pointer
    user-select none
    &.add-icon
      color $green_color
    &.delete-icon
      color $orange_color
.btns-group
  display flex
  justify-content center
  margin 30px 0
</style>

<style lang="stylus">
.add-sup-group
  .el-dialog__header
    border-bottom 1px solid #666
    margin 0 20px
    padding-left 0
    .el-dialog__title
      font-weight normal
      font-size 20px
      color #666
</style>
